
export class ComputingParameter{
    
    constructor(
        /** 
         *  Invista a partir de: lote padrão
         *  Necessário para investir: quantidade
         *  Valor investido: quantidade da ordem
        */
        public amount: number, 
        /** 
         *  Invista a partir de: última cotação
         *  Necessário para investir: última cotação
         *  Valor investido: preço da ordem
        */
        public unitPrice: number, 
        /** 
         Valor percentual
        */
        public quoteFactor: number,
        /**
         * Stress do ativo considerando se é planejado, não planejado ou não planejado day trade
         */
        public stress?: number, 
        /**
         * preço loss
         */
        public lossPrice?: number, 
        /**
         * última cotação do dolptax
         */
        public ptax?: number,
        /**
         * Stress secundário, quando aplicado em cenários que possuem 2 tipos de estresse para calculo
         * Cenário 4, por exemplo.
         */
        public secundaryStress?: number
    ){

    }
}